import React, { useMemo } from 'react';

import { Stack } from '@mui/material';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid-pro';
import { useQuery } from '@tanstack/react-query';

import { FormFilterCentroPedidos } from '..';

import { EditRemoveBtn } from 'components/buttons';
import { PanelGrid } from 'components/grid';
import { Block, OneColumn } from 'components/page';
import { useListagemContext } from 'context/ListagemContext';
import { RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';

const generateCentroPedidoList = (data: any[] | undefined): GridRowsProp => {
    const list = data;

    if (Array.isArray(list) && list.length) {
        return list.map((item, index) => ({
            id: index + 1,
            idCentroPedido: item.idCentroPedido,
            dsCentroPedido: item.dsCentroPedido,
            cdCentroPedido: item.cdCentroPedido,
        }));
    }
    return [];
};

export function CentroPedidoListComp() {
    const { filter, page, sort, limit } = useListagemContext();
    const RequestListagem = useRequestListagem();

    const requestOptions: RequestOptionsType = {
        url: '/gestao/centropedido',
        sort: sort && sort.length > 0 ? sort : [{ property: 'idCentroPedido', direction: 'DESC' }],
        columns: 'idCentroPedido,dsCentroPedido,cdCentroPedido,fgAtivo',
        nested: true,
        filter: [...filter, { property: 'fgAtivo', value: true, operator: 'eq' }],
        page,
        limit,
    };

    const { fetchStatus, data, refetch } = useQuery([requestOptions], () => {
        const request: Promise<any> = RequestListagem(requestOptions).then((res: any) => res.data);
        return request;
    });

    const columns: GridColDef[] = useMemo(
        () => [
            { field: 'idCentroPedido', headerName: 'Código', alignItems: 'center', flex: 1, type: 'string' },
            { field: 'dsCentroPedido', headerName: 'Descrição', alignItems: 'center', flex: 1, type: 'string' },
            { field: 'cdCentroPedido', headerName: 'Código de Integração', alignItems: 'center', flex: 1, type: 'string' },
            {
                field: 'acoes',
                align: 'center',
                headerAlign: 'center',
                headerName: 'Ações',
                filterable: false,
                sortable: false,
                hideable: false,
                disableColumnMenu: true,
                width: 110,
                renderCell: ({ row }) => (
                    <EditRemoveBtn
                        id={row.idCentroPedido}
                        showEditBtn={true}
                        showRemoveBtn={true}
                        removeUrl={`gestao/centropedido/${row.idCentroPedido}`}
                        sx={{ ml: 'auto', p: 1.5 }}
                        refresh={refetch}
                    />
                ),
            },
        ],
        [refetch],
    );

    const rows = generateCentroPedidoList(data?.data);

    return (
        <OneColumn title="Centros de Pedidos" createButton>
            <FormFilterCentroPedidos />

            <Block>
                <PanelGrid rows={rows} rowsCount={data?.total ?? 0} reload={refetch} loading={fetchStatus === 'fetching'} columns={columns} />
            </Block>
        </OneColumn>
    );
}
